import React from 'react';
import { Link } from 'react-router-dom';
import { Music, Heart, Mail } from 'lucide-react';
import instagram from '../../src/img/instagram.png'
const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    main: [
      { name: 'Home', path: '/' },
      { name: 'Search', path: '/search' },
      { name: 'Library', path: '/library' },
      { name: 'Dashboard', path: '/dashboard' },
      { name: 'Favourites', path: '/favourite' },
      { name: 'Chat', path: '/chat' },
    ],
    playlists: [
      { name: 'Create Playlist', path: '/create-playlist' },
      { name: 'Liked Songs', path: '/liked-songs' },
    ],
    premium: [
      { name: 'Premium Plans', path: '/premium' },
    ],
    legal: [
      { name: 'Privacy Policy', path: '/privacy-policy' },
      { name: 'Terms & Conditions', path: '/terms-conditions' },
      { name: 'Cancellation & Refunds', path: '/cancellation-refunds' },
      { name: 'Shipping', path: '/shipping' },
      { name: 'Contact', path: '/contact' },
    ]
  };

  return (
    <footer className="bg-slate-900/50 backdrop-blur-lg border-t border-white/10 mt-auto relative z-10">
      <div className="max-w-7xl mx-auto px-3 xs:px-4 sm:px-6 lg:px-8 xl:px-12 py-6 xs:py-8 sm:py-10 lg:py-12 ml-0 xs:ml-56 sm:ml-64 lg:ml-72 pb-20 sm:pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 xs:gap-7 sm:gap-8">

          {/* Brand Section */}
          <div className="space-y-2 xs:space-y-3 sm:space-y-4 lg:col-span-1">
            <div className="flex items-center gap-2">
              <Music className="w-5 h-5 xs:w-6 xs:h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-purple-500 flex-shrink-0" />
              <span className="text-sm xs:text-base sm:text-lg lg:text-xl font-bold text-white truncate">Sama Music</span>
            </div>
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
              Your ultimate music streaming destination. Discover, stream, and enjoy millions of songs from around the world.
            </p>
            <div className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm text-gray-400">
              <Mail className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
              <span className="break-all sm:break-normal">samasong.music@gmail.com</span>
            </div>
            <div className="flex items-center gap-4 mt-4">
              <a href="https://www.facebook.com/profile.php?id=61585775916125" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <img src="https://www.facebook.com/images/fb_icon_325x325.png" alt="Facebook" className="w-14 h-14" />
              </a>
              <a href="https://www.instagram.com/samasong.music/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <img src={instagram} alt="Instagram" className="w-14 h-14" />
              </a>
            </div>
          </div>
          {/* Main Navigation */}
          <div className="space-y-2 xs:space-y-3 sm:space-y-4">
            <h3 className="text-white font-semibold text-sm sm:text-base lg:text-lg">Navigation</h3>
            <ul className="space-y-1 sm:space-y-2">
              {footerLinks.main.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white active:text-white/80 transition-colors text-xs sm:text-sm touch-manipulation min-h-[40px] sm:min-h-[44px] flex items-center"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Playlists & Features */}
          <div className="space-y-2 xs:space-y-3 sm:space-y-4">
            <h3 className="text-white font-semibold text-sm sm:text-base lg:text-lg">Features</h3>
            <ul className="space-y-1 sm:space-y-2">
              {footerLinks.playlists.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white active:text-white/80 transition-colors text-xs sm:text-sm touch-manipulation min-h-[40px] sm:min-h-[44px] flex items-center"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              {footerLinks.premium.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-purple-400 hover:text-purple-300 active:text-purple-200 transition-colors text-xs sm:text-sm font-medium touch-manipulation min-h-[40px] sm:min-h-[44px] flex items-center"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Support */}
          <div className="space-y-2 xs:space-y-3 sm:space-y-4">
            <h3 className="text-white font-semibold text-sm sm:text-base lg:text-lg">Legal & Support</h3>
            <ul className="space-y-1 sm:space-y-2">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white active:text-white/80 transition-colors text-xs sm:text-sm touch-manipulation min-h-[40px] sm:min-h-[44px] flex items-center"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom Section */}
        <div className="mt-6 xs:mt-7 sm:mt-8 pt-3 xs:pt-4 sm:pt-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <div className="flex items-center gap-1.5 text-xs sm:text-sm text-gray-400 text-center sm:text-left order-2 sm:order-1">
              <span>© {currentYear} Sama Music. Made with</span>
              <Heart className="w-3 h-3 sm:w-4 sm:h-4 text-red-500 fill-current flex-shrink-0" />
              <span>for music lovers.</span>
            </div>
            <div className="flex items-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-400 order-1 sm:order-2">
              <span>Download App:</span>
              <a href="https://drive.google.com/file/d/1tpJ1aU4DYkAao_WxE0ZNmWcLaZSSQeJB/view?usp=drive_link" target="_blank" rel="noopener noreferrer">
                <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" className="h-8 sm:h-10" />
              </a>
              <a href="https://apps.apple.com/app" target="_blank" rel="noopener noreferrer">
                <img src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg" alt="Download on the App Store" className="h-8 sm:h-10" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;